// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"3b3cf0cb","395":"8efbc461","553":"5839086d","661":"5171dca1","665":"25d99a1f","912":"c8bd186f"}[chunkId] + ".chunk.js";
};